import React, { useEffect, useState } from 'react'
import "./Navbar.css";

import {Link} from "react-router-dom";

export default function Navbar() {


    const [active,SetActive] = useState(false);

    const navbarClass = active ? "navbar__all active" : "navbar__all"; 

    const navbarClose = () => {
        SetActive(false); onclick={navbarClose}
    }
    
    return (

        <nav class="navbar">
            <h2 className="navbar__title"><span className="navbar__icon"><i class="fas fa-atom"></i></span> Aravinda krisnnan</h2>
            
            
            <div onClick={()=>{SetActive(!active)}} className="navbar__breadcrumb"><i class="far fa-compass"></i></div>

            <div className={navbarClass}>

            <ul className="navbar__nav">
                <li onClick={navbarClose} className="nav__item"><Link className="nav__link" to="/">Home</Link></li>
                <li onClick={navbarClose} className="nav__item"><Link className="nav__link" to="/projects">Projects</Link></li>
                <li onClick={navbarClose} className="nav__item"><Link className="nav__link" to="/packages">Packages</Link></li>
            </ul>

            <ul className="navbar__links">
                <li className="nav__item"><a className="nav__link" href="https://www.instagram.com/aravindakrishnan.io/"><i class="fab fa-instagram" target="_blank" rel="noreferrer"></i></a></li>
                <li className="nav__item"><a className="nav__link" href="https://www.github.com/Aravindakrishnan" target="_blank" rel="noreferrer"><i class="fab fa-github"></i></a></li>
                <li className="nav__item"><a className="nav__link" href="mailto:aravindapksak@gmail.com"><i class="far fa-envelope" target="_blank" rel="noreferrer"></i></a></li>
            </ul>
            </div>

        </nav>

                  



    )
}
